<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="设备名称">
              <a-input placeholder="请输入设备名称" v-model="queryParam.videoName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="服务平台">
              <j-dict-select-tag dictCode="video_server" placeholder="请选择服务平台" v-model="queryParam.serverId" />
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('视频设备')" icon="download" type="primary">导出</a-button>
      <a-upload
        :action="importExcelUrl"
        :headers="tokenHeader"
        :multiple="false"
        :showUploadList="false"
        @change="handleImportExcel"
        name="file"
      >
        <a-button icon="import" type="primary">导入</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleModal(record)">预览</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <video-modal @ok="videoModalFormOk" ref="videoModal" />
    <video-device-modal @ok="modalFormOk" ref="modalForm"></video-device-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import VideoDeviceModal from './modules/VideoDeviceModal'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
  import VideoModal from '@/components/VideoModal'
  export default {
    name: 'VideoDeviceList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      VideoDeviceModal, VideoModal
    },
    data () {
      return {
        description: '视频设备管理页面',
        isorter: {
          column: 'videoName',
          order: 'asc'
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '设备名称',
            align: "center",
            dataIndex: 'videoName',
            sorter: true,
          },
          {
            title: '设备序列号',
            align: "center",
            dataIndex: 'deviceId',
            sorter: true,
          },
          {
            title: '通道号',
            align: "center",
            dataIndex: 'channelId',
            sorter: true,
          },
          {
            title: '服务平台',
            align: "center",
            dataIndex: 'serverId_dictText',
            sorter: true,
          },
          {
            title: '供水流域',
            align: "center",
            dataIndex: 'processId_dictText',
            sorter: true,
          },
          {
            title: 'app_key',
            align: "center",
            dataIndex: 'appKey'
          },
          {
            title: 'app_secret',
            align: "center",
            dataIndex: 'appSecret'
          },
          {
            title: 'access_token',
            align: "center",
            dataIndex: 'accessToken'
          },
          {
            title: '直播地址',
            align: "center",
            dataIndex: 'liveUrl'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 178,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/video/videoDevice/list",
          delete: "/video/videoDevice/delete",
          deleteBatch: "/video/videoDevice/deleteBatch",
          exportXlsUrl: "/video/videoDevice/exportXls",
          importExcelUrl: "video/videoDevice/importExcel",

        },
        dictOptions: {},
        superFieldList: [],
        videoModalShow: false
      }
    },
    created () {
      this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'videoName', text: '设备名称', dictCode: '' })
        fieldList.push({ type: 'string', value: 'deviceId', text: '设备序列号', dictCode: '' })
        fieldList.push({ type: 'string', value: 'channelId', text: '通道号', dictCode: '' })
        fieldList.push({ type: 'string', value: 'serverId', text: '服务平台', dictCode: 'video_server' })
        fieldList.push({ type: 'string', value: 'appKey', text: 'app_key', dictCode: '' })
        fieldList.push({ type: 'string', value: 'appSecret', text: 'app_secret', dictCode: '' })
        fieldList.push({ type: 'string', value: 'accessToken', text: 'access_token', dictCode: '' })
        fieldList.push({ type: 'string', value: 'liveUrl', text: '直播地址', dictCode: '' })
        this.superFieldList = fieldList
      },
      handleModal (record) {

        this.$refs.videoModal.show(record)
        this.$refs.videoModal.title = '视频'
        this.$refs.videoModal.disableSubmit = false
      },
      videoModalFormOk () {
        this.videoModalShow = false
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>